// extracted by mini-css-extract-plugin
module.exports = {"loader":"ImprintPage_loader__2oDZu","root":"ImprintPage_root__2Z-II","lastUpdated":"ImprintPage_lastUpdated__emcf9","content":"ImprintPage_content__14Fgp"};